import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const SocialShare = ({ fileName, veracity }) => {
  const shareText = `I just used the AI Photo Investigator to analyze "${fileName}". Veracity Score: ${veracity}%. Detect AI-generated images locally at takedowntaskforce.com!`;
  const url = "https://takedowntaskforce.com";
  
  const platforms = [
    { name: 'Twitter', icon: FiIcons.FiTwitter, href: `https://twitter.com/intent/tweet?text=${encodeURIComponent(shareText)}`, color: 'bg-[#1DA1F2]' },
    { name: 'LinkedIn', icon: FiIcons.FiLinkedin, href: `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`, color: 'bg-[#0A66C2]' },
    { name: 'Facebook', icon: FiIcons.FiFacebook, href: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`, color: 'bg-[#1877F2]' }
  ];

  const handleShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: 'AI Forensic Report',
          text: shareText,
          url: url,
        });
      } catch (err) {
        console.error("Error sharing:", err);
      }
    }
  };

  return (
    <div className="mt-6 pt-6 border-t border-slate-100/10">
      <div className="mb-4 text-center">
        <p className="text-[10px] font-black uppercase tracking-[0.2em] text-blue-500 mb-1">Credit</p>
        <p className="text-xs font-semibold text-slate-400">Analysis powered by Takedown Taskforce Forensic Engine</p>
      </div>

      <p className="text-xs font-bold text-slate-500 uppercase tracking-widest mb-3 text-center">Share Analysis</p>
      <div className="flex gap-2 justify-center">
        {platforms.map((p) => (
          <a
            key={p.name}
            href={p.href}
            target="_blank"
            rel="noopener noreferrer"
            className={`${p.color} text-white p-2.5 rounded-lg hover:opacity-90 transition shadow-sm`}
            title={`Share on ${p.name}`}
          >
            <SafeIcon icon={p.icon} className="text-lg" />
          </a>
        ))}
        <button 
          onClick={handleShare}
          className="bg-slate-800 text-slate-300 p-2.5 rounded-lg hover:bg-slate-700 transition shadow-sm"
          title="More sharing options"
        >
          <SafeIcon icon={FiIcons.FiShare2} className="text-lg" />
        </button>
      </div>
    </div>
  );
};

export default SocialShare;